import { SecondaryButton } from '@designsforhealth/dfh-react-components'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

const HeaderWithSecondaryButton = ({
  buttonHidden,
  buttonText,
  className,
  headerText,
  onClick,
  buttonDisabled,
}) => (
  <header className={className}>
    <h3>{headerText}</h3>
    {!buttonHidden && (
      <SecondaryButton onClick={onClick} disabled={buttonDisabled}>
        {buttonText}
      </SecondaryButton>
    )}
  </header>
)

HeaderWithSecondaryButton.defaultProps = {
  className: '',
  buttonDisabled: false,
  buttonHidden: false,
}

HeaderWithSecondaryButton.propTypes = {
  buttonHidden: PropTypes.bool,
  buttonText: PropTypes.node.isRequired,
  className: PropTypes.string,
  buttonDisabled: PropTypes.bool,
  headerText: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
}

const StyledHeaderWithSecondaryButton = styled(HeaderWithSecondaryButton)({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginBottom: '20px',
  button: {
    flex: '0 1 172px',
    marginLeft: '15px',
    '--btn-line-height': 'normal',
    '@media print': {
      display: 'none',
    },
  },
  h3: {
    marginBottom: '0',
  },
})

export default StyledHeaderWithSecondaryButton
